<div class="bg-primary p-4 text-white rounded-t flex justify-between items-center">
  <h2 class="text-lg font-semibold">Order Change History</h2>
</div>

<div class="bg-white p-4 rounded-b shadow flex flex-col h-[400px]">
  <div class="flex-1 overflow-y-auto border-b border-gray-200">
    <div
      *ngFor="let log of orderDetails?.historyLogs; trackBy: trackByLogId"
      class="py-3 border-b border-gray-100 last:border-b-0 text-gray-800"
    >
      <div>
        <span class="font-medium">{{ log.user.firstName }} {{ log.user.lastName }} </span>
        <span class="">{{ log.description }}</span>
      </div>
      <div class="text-xs text-gray-500 mt-1">
        {{ log.dateCreated | date: 'MM/dd/yyyy hh:mm a' }}
      </div>
    </div>
  </div>
</div>
